import { useQueryClient } from "@tanstack/react-query";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useCreateFeedLikeWeb,
  useDeleteFeedLikeWeb,
} from "../recommendFeed/model";
import { CourseBadge, DividerThin } from "../../../../shared";
import { Flex, Modal } from "antd";
import { ReactComponent as More } from "../../../../assets/images/icon/more.svg";
import { ReactComponent as FillOff } from "../../../../assets/images/icon/fill=off.svg";
import { ReactComponent as FillOn } from "../../../../assets/images/icon/fill=on.svg";
import { ReactComponent as Bubble } from "../../../../assets/images/icon/bubble.svg";
import { ReactComponent as EyeDisable } from "../../../../assets/images/icon/eye-disable.svg";
import { ReactComponent as Close } from "../../../../assets/images/icon/close.svg";
import { ReactComponent as Warning } from "../../../../assets/images/icon/warning.svg";
import LoadingV2 from "../../../../assets/images/lottie/loadingV2.json";
import CommunityLike from "../../../../assets/images/lottie/coummunity_like.json";
import Lottie from "lottie-react";
import { formatRelativeDate } from "../../../../utils";
import { useEffect, useState } from "react";
import "./index.css";
import { useMyContext } from "../../../../entities/context";

interface IProps {
  feed: Omit<IGetMyFeedWebResponse, "isShow" | "isPrivate"> &
  Partial<Pick<IGetMyFeedWebResponse, "isShow" | "isPrivate">>;
  setSelectedFeed: Function;
  setIsShowBottomSheet: Function;
  isLoading?: boolean;
  isMyFeed: boolean;
}

const FeedCard = ({
  feed,
  setSelectedFeed,
  setIsShowBottomSheet,
  isLoading,
  isMyFeed,
}: IProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { createFeedId } = location.state ?? {};
  const [imageModalOpen, setImageModalOpen] = useState<boolean>(false);
  const [selectedImage, setSelectedImage] = useState<string>("");
  const [isLikeAnimationEnd, setIsLikeAnimationEnd] = useState<boolean>(true);
  const queryClient = useQueryClient();
  const createFeedLikeWeb = useCreateFeedLikeWeb();
  const deleteFeedLikeWeb = useDeleteFeedLikeWeb();
  const { topHeight, setCommunityTabKey } = useMyContext();
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const [touchStartX, setTouchStartX] = useState<number | null>(null);
  const [touchEndX, setTouchEndX] = useState<number | null>(null);

  const [touchStartY, setTouchStartY] = useState<number | null>(null);
  const [touchEndY, setTouchEndY] = useState<number | null>(null);

  const currentImage = feed.imageUrlList[selectedIndex];

  useEffect(() => {
    if (createFeedId) {
      setTimeout(() => {
        navigate("#", { replace: true });
      }, 500);
    }
  }, []);

  return (
    <>
      <DividerThin />
      <div
        style={{ position: "relative" }}
        onClick={() => {
          setCommunityTabKey(isMyFeed ? 1 : 0);
          navigate(`/community/feed/${feed.id}`);
        }}
      >
        <div
          style={{
            padding: "20px",
            opacity: isLoading ? 0.3 : 1,
            backgroundColor:
              isMyFeed && feed.isHiddenByClaim === true
                ? "var(--secondarys100)"
                : "",
          }}
        >
          {isMyFeed && feed.isHiddenByClaim === true && (
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: "12px" }}>
              <div style={{ display: "flex", gap: "4px", }}>
                <Warning width={16} height={16} fill="var(--errore500)" />
                <div>
                  <div
                    className="caption/c1 error/e600"
                    style={{ marginBottom: "2px" }}
                  >
                    운영정책 위반으로 숨김 처리된 게시글입니다.
                  </div>
                  <div className="body/b1 secondary/s800">
                    이유: {feed.hiddenReason}
                  </div>
                </div>
              </div>
              <More
                fill="var(--secondarys400)"
                onClick={(q) => {
                  q.stopPropagation();
                  setSelectedFeed(feed);
                  setIsShowBottomSheet(true);
                }}
              />
            </div>
          )}
          <Flex justify="space-between" style={{ marginBottom: "8px" }}>
            <Flex style={{ alignItems: "center" }} gap={8}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "4px" }}
              >
                <div className="sub-title/st2">{feed.nickName}</div>
                {feed.isBadgeShow && (
                  <CourseBadge
                    style={{
                      width: "auto",
                      color: "var(--secondarys100)",
                      backgroundColor: "var(--secondarys800)",
                      padding: "2px 4px",
                      borderRadius: "var(--radius2)",
                    }}
                    children="Coach"
                  />
                )}
              </div>
              <div className="caption/c1 secondary/s500">
                {formatRelativeDate(feed.createdDate)}
              </div>
              {isMyFeed && feed.isShow === false && (
                <EyeDisable
                  width={16}
                  height={16}
                  stroke="var(--secondarys400)"
                  fill="var(--secondarys400)"
                />
              )}
            </Flex>
            {!(isMyFeed && feed.isHiddenByClaim === true) &&
              <More
                fill="var(--secondarys400)"
                onClick={(q) => {
                  q.stopPropagation();
                  setSelectedFeed(feed);
                  setIsShowBottomSheet(true);
                }}
              />}
          </Flex>

          <div style={{ marginBottom: "12px" }}>
            <div
              className="body/b3 secondary/s850"
              style={{ marginBottom: 8, whiteSpace: "pre-wrap" }}
            >
              {feed.content}
            </div>
            {feed.imageUrlList.length === 1 ? (
              <img
                src={feed.imageUrlList[0]}
                style={{
                  width: "calc(100vw - 40px)",
                  display: "block",
                  maxWidth: "440px",
                  height: "auto",
                  border: "1px solid rgba(0, 0, 0, 0.05)",
                  borderRadius: 4,
                  objectFit: "cover",
                }}
                onClick={(q) => {
                  q.stopPropagation();
                  setImageModalOpen(true);
                  setSelectedImage(feed.imageUrlList[0]);
                }}
              />
            ) : (
              <>
                <Flex
                  style={{
                    overflowX: "auto",
                    paddingLeft: 0,
                    paddingRight: 20,
                    marginLeft: -20,
                    marginRight: -20,
                  }}
                  gap={12}
                >
                  {feed.imageUrlList.map((imageUrl, idx) => {
                    return (
                      <img
                        key={idx}
                        src={imageUrl}
                        style={{
                          width: "auto",
                          height: "25vh",
                          border: "1px solid rgba(0, 0, 0, 0.05)",
                          borderRadius: 4,
                          marginLeft: idx === 0 ? 20 : 0,
                          flexShrink: 0,
                        }}
                        onClick={(q) => {
                          q.stopPropagation();
                          setImageModalOpen(true);
                          setSelectedImage(imageUrl);
                          setSelectedIndex(idx);
                        }}
                      />
                    );
                  })}
                </Flex>
              </>
            )}
          </div>
          <div>
            <Flex gap={12}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                {feed.isCreatedLike ? (
                  isLikeAnimationEnd ? (
                    <FillOn
                      style={{ color: "var(--errore400)" }}
                      onClick={(q) => {
                        q.stopPropagation();
                        setIsLikeAnimationEnd(true);
                        !deleteFeedLikeWeb.isPending &&
                          deleteFeedLikeWeb.mutate(feed.id, {
                            onSuccess: (res) => {
                              if (res.data) {
                                queryClient.invalidateQueries({
                                  predicate: (query) => {
                                    return Array.isArray(query.queryKey) && query.queryKey[0] === 'feedList';
                                  }
                                });
                              }
                            },
                          });
                      }}
                    />
                  ) : (
                    <Lottie
                      onClick={(q) => q.stopPropagation()}
                      style={{
                        width: 30,
                        height: 30,
                        margin: "-5px",
                        color: "var(--errore400)",
                        WebkitTapHighlightColor: "transparent",
                      }}
                      animationData={CommunityLike}
                      autoplay={true}
                      loop={false}
                      onComplete={() => {
                        setIsLikeAnimationEnd(true);
                      }}
                    />
                  )
                ) : (
                  <FillOff
                    onClick={(q) => {
                      q.stopPropagation();
                      !createFeedLikeWeb.isPending &&
                        createFeedLikeWeb.mutate(feed.id, {
                          onSuccess: (res) => {
                            if (res.data) {
                              setIsLikeAnimationEnd(false);
                              queryClient.invalidateQueries({
                                predicate: (query) => {
                                  return Array.isArray(query.queryKey) && query.queryKey[0] === 'feedList';
                                }
                              });
                            }
                          },
                        });
                    }}
                  />
                )}
                <div className="body/b1 secondary/s500">
                  {feed.feedLikeCnt >= 1000
                    ? "999+"
                    : feed.feedLikeCnt.toLocaleString()}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  WebkitTapHighlightColor: "transparent",
                }}
                onClick={(q) => {
                  q.stopPropagation();
                  navigate(`/community/feed/${feed.id}`, {
                    state: { isInputComment: true },
                  });
                }}
              >
                <Bubble />
                <div className="body/b1 secondary/s500">
                  {feed.feedCommentCnt >= 1000
                    ? "999+"
                    : feed.feedCommentCnt.toLocaleString()}
                </div>
              </div>
            </Flex>
          </div>
        </div>
        {isLoading ||
          (createFeedId === feed.id && (
            <>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "100%",
                  height: "100%",
                  opacity: 0.7,
                  backgroundColor: "white",
                }}
              ></div>
              <Lottie
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 60,
                  height: 60,
                  opacity: 0.7,
                }}
                animationData={LoadingV2}
                autoplay={true}
              />
            </>
          ))}
      </div>

      <Modal
        classNames={{ wrapper: "custom_image_modal" }}
        centered
        open={imageModalOpen}
        styles={{
          wrapper: { backgroundColor: "var(--baseblack)" },
          content: { padding: 0 },
        }}
        onCancel={() => setImageModalOpen(false)}
        closeIcon={null}
        footer={null}
      >
        <img
          src={currentImage}
          style={{
            width: "100vw",
            display: "block",
            maxWidth: "440px",
            height: "auto",
            objectFit: "cover",
            touchAction: "none",
            transition: "transform 0.3s ease",
          }}
          onTouchStart={(e) => {
            setTouchStartX(e.touches[0].clientX);
            setTouchStartY(e.touches[0].clientY);
          }}
          onTouchMove={(e) => {
            setTouchEndX(e.touches[0].clientX);
            setTouchEndY(e.touches[0].clientY);
          }}
          onTouchEnd={() => {
            if (touchStartX !== null && touchEndX !== null) {
              const diffX = touchEndX - touchStartX;

              if (diffX < -50 && selectedIndex < feed.imageUrlList.length - 1) {
                setSelectedIndex((prev) => prev + 1);
              } else if (diffX > 50 && selectedIndex > 0) {
                setSelectedIndex((prev) => prev - 1);
              }
            }

            if (touchStartY !== null && touchEndY !== null) {
              const diffY = touchEndY - touchStartY;
              if (diffY > 100) {
                setImageModalOpen(false);
              }
            }

            setTouchStartX(null);
            setTouchEndX(null);
            setTouchStartY(null);
            setTouchEndY(null);
          }}
        />
      </Modal>
      {imageModalOpen && (
        <Close
          width={24}
          height={24}
          stroke="var(--basewhite)"
          style={{
            position: "fixed",
            top: topHeight ?? 16,
            left: 16,
            zIndex: 1003,
            padding: "12px",
            cursor: "pointer",
          }}
          onClick={() => setImageModalOpen(false)}
        />
      )}
    </>
  );
};

export default FeedCard;
